import { z } from 'zod';
// ---------------------------------------------------------------------------
// Existing schemas (backward compatible)
// ---------------------------------------------------------------------------
export const OnboardingStateSchema = z.object({
    currentStep: z.number().int().min(0),
    completedSteps: z.array(z.string()),
    startedAt: z.string().datetime(),
    completedAt: z.string().datetime().optional(),
});
export const OnboardingEventSchema = z.object({
    type: z.string(),
    step: z.string(),
    timestamp: z.string().datetime(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const CliToolSchema = z.object({
    name: z.string(),
    detected: z.boolean(),
    version: z.string().optional(),
});
// ---------------------------------------------------------------------------
// Story 8.9: SSE onboarding stream schemas
// ---------------------------------------------------------------------------
export const OnboardingStepEnum = z.enum([
    'welcome',
    'payment',
    'install_auth',
    'first_generation',
]);
export const OnboardingSseEventType = z.enum([
    'connected',
    'heartbeat',
    'step_completed',
    'payment_confirmed',
    'generation_started',
    'generation_completed',
    'generation_failed',
]);
// Expanded from the original MCP-only event enum — now includes backend-originating events
// (payment_confirmed from Stripe webhook, generation_* from pipeline)
export const OnboardingEventType = z.enum([
    'mcp_installed',
    'mcp_authenticated',
    'payment_confirmed',
    'generation_started',
    'generation_completed',
    'generation_failed',
]);
/** @deprecated Use OnboardingEventType instead */
export const OnboardingMcpEventType = OnboardingEventType;
export const CliToolName = z.enum(['claude-code', 'cursor', 'codex-cli', 'gemini-cli']);
export const OnboardingKvStateSchema = z.object({
    currentStep: z.number().int().min(0),
    completedSteps: z.array(z.string()),
    startedAt: z.string(),
    completedAt: z.string().optional(),
    cliTool: CliToolName.optional(),
    mcpInstalled: z.boolean(),
    mcpAuthenticated: z.boolean(),
    planPaid: z.boolean(),
    firstGenerationComplete: z.boolean(),
    firstGenerationPreview: z.string().optional(),
    firstGenerationError: z.string().optional(),
    completed: z.boolean().default(false),
    updatedAt: z.number(),
});
export const OnboardingEventPayloadSchema = z
    .object({
    event: OnboardingEventType,
    cli_type: CliToolName.optional(),
    userId: z.string().min(1),
    preview: z.string().optional(),
})
    .refine((data) => data.event !== 'mcp_installed' || data.cli_type !== undefined, {
    message: 'cli_type is required for mcp_installed events',
    path: ['cli_type'],
});
export const OnboardingSsePayloadSchema = z.object({
    step: z.string(),
    status: z.string(),
    timestamp: z.string(),
    mcpInstalled: z.boolean().optional(),
    mcpAuthenticated: z.boolean().optional(),
    planPaid: z.boolean().optional(),
});
//# sourceMappingURL=onboarding.js.map